import { Account } from '../models/account.model';

export type AccountPanelEventType = 'login_completed' | 'session_expires' | 'session_close';

/**
 * Entity class that define authentication events
 */
export class AccountPanelEvent<
  T = {
    account: Account | null;
  }
> {
  type: AccountPanelEventType;
  info: T | null;

  constructor(type: AccountPanelEventType, info: T | null = null) {
    this.type = type;
    this.info = info;
  }
}
